function remToPx(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
// In the design, the arrow is a 1.41rem square rotated diagonally and cut in half.
var arrowSize = function () { return remToPx(2); };
// The horizontal top/bottom positions have the arrow at a ~10px offset from the edge.
var arrowOffset = function () { return remToPx(1); };
export var positioningLogic = {
    'top-center': function (popover, trigger) {
        return {
            top: trigger.top - popover.height - arrowSize() / 2,
            left: trigger.left + trigger.width / 2 - popover.width / 2,
            width: popover.width,
            height: popover.height
        };
    },
    'bottom-center': function (popover, trigger) {
        return {
            top: trigger.top + trigger.height + arrowSize() / 2,
            left: trigger.left + trigger.width / 2 - popover.width / 2,
            width: popover.width,
            height: popover.height
        };
    },
    'right-top': function (popover, trigger) {
        return {
            top: trigger.top + trigger.height / 2 - arrowOffset() - arrowSize() / 2,
            left: trigger.left + trigger.width + arrowSize() / 2,
            width: popover.width,
            height: popover.height
        };
    },
    'right-bottom': function (popover, trigger) {
        return {
            top: trigger.top + trigger.height / 2 - popover.height + arrowOffset() + arrowSize() / 2,
            left: trigger.left + trigger.width + arrowSize() / 2,
            width: popover.width,
            height: popover.height
        };
    },
    'left-top': function (popover, trigger) {
        return {
            top: trigger.top + trigger.height / 2 - arrowOffset() - arrowSize() / 2,
            left: trigger.left - popover.width - arrowSize() / 2,
            width: popover.width,
            height: popover.height
        };
    },
    'left-bottom': function (popover, trigger) {
        return {
            top: trigger.top + trigger.height / 2 - popover.height + arrowOffset() + arrowSize() / 2,
            left: trigger.left - popover.width - arrowSize() / 2,
            width: popover.width,
            height: popover.height
        };
    },
    'bottom-responsive': function () {
        // this requires guesswork :/
        // the popover will reflow after we set the width so we can't know the height yet
        return undefined;
    },
    'top-responsive': function () { return undefined; }
};
//# sourceMappingURL=positioning-logic.js.map